<!--statistic_48dp_FILL1_wght400_GRAD0_opsz48-->
<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="48px" width="48px">
    <path d="M14.2 34.15h3V20.4h-3Zm8.3 0h3v-20.3h-3Zm8.3 0h3v-7.4h-3ZM9 42q-1.2 0-2.1-.9Q6 40.2 6 39V9q0-1.2.9-2.1Q7.8 6 9 6h30q1.2 0 2.1.9.9.9.9 2.1v30q0 1.2-.9 2.1-.9.9-2.1.9Z"/>
  </svg>
</template>
